import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { reportError } from "../lib/errorReporter";
import Layout from "../components/Layout";
import { fmtDateTime } from "../lib/format";

export default function NotificationsList() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/notifications");
      setItems(r.data || []);
    } catch (err) {
      // Non-fatal: keep whatever was previously displayed.
      reportError("notificationsList.load", err);
    }
  }, []);

  useEffect(() => {
    load();
    const onOrg = () => load();
    window.addEventListener("quowada:orgChanged", onOrg);
    return () => window.removeEventListener("quowada:orgChanged", onOrg);
  }, [load]);

  const markRead = useCallback(
    async (n) => {
      try {
        await api.post(`/notifications/${n.id}/read`);
      } catch (err) {
        reportError("notificationsList.markRead", err);
      }
      if (n.quotation_id) nav(`/quotations/${n.quotation_id}`);
      else load();
    },
    [nav, load],
  );

  const markAll = useCallback(async () => {
    try {
      await api.post("/notifications/read-all");
      load();
    } catch (err) {
      reportError("notificationsList.markAll", err);
    }
  }, [load]);

  return (
    <Layout
      title={t("notifications.title")}
      actions={
        <button className="qw-btn" onClick={markAll} data-testid="btn-mark-all-read">
          {t("notifications.mark_all_read")}
        </button>
      }
    >
      <div className="h1">{t("notifications.title")}</div>
      <div style={{ height: 20 }} />
      {items.length === 0 ? (
        <div className="qw-card qw-empty">{t("notifications.empty")}</div>
      ) : (
        <div className="qw-card" style={{ padding: 0 }}>
          {items.map((n) => (
            <div
              key={n.id}
              data-testid={`notif-item-${n.id}`}
              className={String(n.type || "").startsWith("email.") ? "qw-notif-alert" : undefined}
              onClick={() => markRead(n)}
              style={{
                padding: 14,
                borderBottom: "1px solid #e2e8f0",
                background: n.is_read ? "#fff" : "#ecfeff",
                cursor: "pointer",
              }}
            >
              <div className="hstack" style={{ justifyContent: "space-between" }}>
                <div style={{ fontWeight: 600 }} className="qw-break">{n.title}</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>{fmtDateTime(n.created_at)}</div>
              </div>
              <div style={{ fontSize: 13, color: "#475569", marginTop: 4 }} className="qw-break">{n.body}</div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
